
import { nav } from './nav';
import { auth } from './auth';
import { landing } from './landing';
import { assessment } from './assessment';
import { profile, chart, traits, personality, professional, workStyle, communication } from './profile';
import { words } from './words';
import { cognitive } from './cognitive';
import { profiles } from './profiles';
import { buttons, language, userForm, errors, common } from './common';
import { results, factors, insights, tabs, objectivity } from './results';
import { training } from './training';

export const es = {
  nav,
  buttons,
  language,
  userForm,
  auth,
  landing,
  assessment,
  profile,
  chart,
  traits,
  personality,
  professional,
  workStyle,
  communication,
  results,
  factors,
  insights,
  tabs,
  errors,
  common,
  words,
  cognitive,
  profiles,
  objectivity,
  training
};
